import ProfileModel from '@/store/models/ProfileModel'
import { addScript } from '@/utils/dom'
import { API_DELETE_PROFILE_URL, API_GET_PROFILES_URL, API_SAVE_PROFILE_URL } from '@/config'
import axios from 'axios'
import ClientProfile from '@/store/models/ClientProfile'
import BaseConfig from '@/data/baseconfig'

declare var window: any
let config: BaseConfig

export function addScriptPromise (url: string, variableName: string): Promise<any> {
  return new Promise((resolve, reject) => {
    try {
      addScript(
        url,
        () => {
          if (window.hasOwnProperty(variableName)) {
            if (window[variableName]) {
              const dataObject = { data: window[variableName].toString() }
              resolve(dataObject)
            }
          }
        },
        () => reject(new Error('Error loading optician data.'))
      )
    } catch (err) {
      reject(err)
    }
  })
}

export async function deleteProfile (id: string) {
  await axios({
    method: 'POST',
    params: {
      id
    },
    url: `${config.url + API_DELETE_PROFILE_URL}`
  })
}

export function setConfig (baseConfig: BaseConfig) {
  config = baseConfig
}

export function getOpticianData (oCode?: string, offlineMode: boolean = false): Promise<any> {
  const url = (offlineMode)
    ? `${process.env.BASE_URL}data/data.json`
    : `${config.url}json.aspx?ocode=${oCode}`

  return (offlineMode)
    ? addScriptPromise(url, 'data')
    : addScriptPromise(url, 'data')
}

export async function getProfiles (oCode: string) {
  return axios({
    method: 'GET',
    params: {
      ocode: oCode,
      data: 0
    },
    url: `${config.url + API_GET_PROFILES_URL}`
  })
}

export async function loadProfile (id: string) {
  if (!id) {
    return new ProfileModel()
  }
  // @todo load profile by id

  await axios.get(`${config.url + API_GET_PROFILES_URL}`)

  return new ProfileModel()
}

export async function saveProfile (opticianId: string, profile: ClientProfile) {
  await axios({
    method: 'POST',
    params: {
      anoniem: (profile.name.length) ? 0 : 1,
      naam: profile.name,
      opticien_id: opticianId,
      id: profile.hasOwnProperty('id') ? profile.id : ''
    },
    headers: {
      'content-type': 'application/x-www-form-urlencoded'
    },
    url: `${config.url + API_SAVE_PROFILE_URL}`,
    data: profile
  })
}
